import type { ReactNode } from "react";
import { IntlProvider } from "react-intl";
import messages from "@/translations/translation.en";

interface IntlProviderWrapperProps {
  children: ReactNode;
}

// `locale` (and `messages`) are hardcoded to English for now — this is the
// only place a locale is selected, so future language switching (reading a
// user preference, a locale route segment, etc.) hooks in here by swapping
// this hardcoded value for a dynamic one.
const locale = "en";

export function IntlProviderWrapper({ children }: IntlProviderWrapperProps) {
  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
}
